import React, { useEffect, useRef } from "react";

function useHorizontalScrollReset(deps = []) {
  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollLeft = 0;
    }
  }, deps);

  return scrollRef;
}

function useVerticalScrollReset(deps = []) {
  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = 0;
    }
  }, deps);

  return scrollRef;
}

export { useHorizontalScrollReset, useVerticalScrollReset };